import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { assessors as assessorsLayout } from 'constants/layout'
import { renderRoutes } from 'react-router-config'

const enhance = compose(
  connect(({ api }) => ({
    configuration: api.configuration
  }))
)

class AssessorsList extends Component {
  static propTypes = {
    children: PropTypes.any,
    tabs: PropTypes.any.isRequired,
    configuration: PropTypes.object.isRequired,
    route: PropTypes.object
  }

  render () {
    const { tabs, children, configuration, route } = this.props

    const extraProps = {
      route
    }

    return (
      <div>
        {React.cloneElement(tabs, {
          links: assessorsLayout.assessorsListTabs,
          // overview,
          configuration
        })}
        {children
          ? React.cloneElement(children, extraProps)
          : renderRoutes(route.routes, extraProps)}
      </div>
    )
  }
}

export default enhance(AssessorsList)
